// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.region-overview-header {
  margin-left: 0;
}

.region-selection-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  margin: 16px 0;
}

.region-semester-tabs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.school-year-select {
  display: flex;
  align-items: center;
}

.region-name-title {
  margin-top: 10px;
  margin-bottom: 20px;
}

.region-loading-container {
  padding: 40px;
}

.region-table-wrapper {
  margin-top: 20px;
  width: 100%;
  overflow-x: auto;
}

.region-table {
  text-align: center;
  width: 100%;
  min-width: max-content;
  /* Forces the table to expand and trigger horizontal scroll */
}

.region-table th {
  text-align: center;
}

.region-table .td-location-name {
  text-align: left;
}

.th-w-120 {
  width: 120px;
  min-width: 120px;
}

.th-w-280 {
  width: 280px;
  min-width: 280px;
}

.table-header-button {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
}

.header-btn-label {
  flex: 1;
  text-align: center;
  white-space: nowrap;
}

.header-btn-label-with-icon {
  flex: 1;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
}

.header-btn-sort {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.sort-icon {
  height: 16px;
}

.sort-icon-bottom {
  height: 16px;
  margin-bottom: 5px;
}

.info-icon {
  cursor: pointer;
}

.grade-tags {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: nowrap;
}

.grade-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
}

.grade-tag-label {
  font-size: 11px;
  line-height: 1;
}

/* Tablet & Mobile Layout Adaptations */
@media screen and (max-width: 850px) {
  /* Stack selection pieces vertically */
  .region-selection-container {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
  /* Put tabs underneath select dropdown and stack tabs */
  .region-semester-tabs {
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }
  .region-semester-tabs button {
    width: 100% !important;
    /* Force tab buttons to stretch to screen width */
    max-width: none;
  }
  /* Convert Row-Table into Flex Cards */
  .region-table,
  .region-table tbody,
  .region-table tr,
  .region-table td {
    display: block;
    width: 100%;
  }
  .region-table {
    min-width: unset;
    /* Remove the scroll-triggering min-width for mobile card view */
    border: none;
  }
  .region-table thead {
    display: none;
    /* Hide normal headers entirely */
  }
  .region-table tr {
    margin-bottom: 24px;
    border: 1px solid #ccc;
    border-radius: 8px;
    /* Outline and round each row conceptually as a card */
    padding: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    /* Subtle shadow lift */
  }
  .region-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: right;
    padding: 12px 10px;
    border-bottom: 1px solid #eee;
  }
  .region-table td:last-child {
    border-bottom: none;
    /* Bottom border unneeded on last item inside card */
  }
  .region-table td::before {
    content: attr(data-label);
    /* Render the dynamic label from our JS */
    font-weight: bold;
    text-align: left;
    margin-right: 16px;
    color: #444;
  }
  /* Adapt children like tag arrays for tight space */
  .grade-tags {
    flex-wrap: wrap;
    justify-content: flex-end;
    max-width: 65%;
    /* Soft constraint so many tags wrap instead of overriding the label */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/RegionOverviewHome.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,6DAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AACJ;;AAEA;EACI,OAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,OAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,kBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,QAAA;EACA,uBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;AACJ;;AAEA,uCAAA;AACA;EAEI,sCAAA;EACA;IACI,sBAAA;IACA,oBAAA;IACA,SAAA;EAAN;EAGE,uDAAA;EACA;IACI,sBAAA;IACA,WAAA;IACA,eAAA;EADN;EAIE;IACI,sBAAA;IACA,iDAAA;IACA,eAAA;EAFN;EAKE,sCAAA;EACA;;;;IAII,cAAA;IACA,WAAA;EAHN;EAME;IACI,gBAAA;IACA,gEAAA;IACA,YAAA;EAJN;EAOE;IACI,aAAA;IACA,iCAAA;EALN;EAQE;IACI,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,sDAAA;IACA,YAAA;IACA,yCAAA;IACA,uBAAA;EANN;EASE;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,6BAAA;EAPN;EAUE;IACI,mBAAA;IACA,oDAAA;EARN;EAWE;IACI,yBAAA;IACA,yCAAA;IACA,iBAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;EATN;EAYE,mDAAA;EACA;IACI,eAAA;IACA,yBAAA;IACA,cAAA;IACA,sEAAA;EAVN;AACF","sourcesContent":[".region-overview-header {\n    margin-left: 0;\n}\n\n.region-selection-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    width: 100%;\n    margin: 16px 0;\n}\n\n.region-semester-tabs {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.school-year-select {\n    display: flex;\n    align-items: center;\n}\n\n.region-name-title {\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.region-loading-container {\n    padding: 40px;\n}\n\n.region-table-wrapper {\n    margin-top: 20px;\n    width: 100%;\n    overflow-x: auto;\n}\n\n.region-table {\n    text-align: center;\n    width: 100%;\n    min-width: max-content;\n    /* Forces the table to expand and trigger horizontal scroll */\n}\n\n.region-table th {\n    text-align: center;\n}\n\n.region-table .td-location-name {\n    text-align: left;\n}\n\n.th-w-120 {\n    width: 120px;\n    min-width: 120px;\n}\n\n.th-w-280 {\n    width: 280px;\n    min-width: 280px;\n}\n\n.table-header-button {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 4px;\n}\n\n.header-btn-label {\n    flex: 1;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.header-btn-label-with-icon {\n    flex: 1;\n    text-align: center;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    white-space: nowrap;\n}\n\n.header-btn-sort {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.sort-icon {\n    height: 16px;\n}\n\n.sort-icon-bottom {\n    height: 16px;\n    margin-bottom: 5px;\n}\n\n.info-icon {\n    cursor: pointer;\n}\n\n.grade-tags {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    flex-wrap: nowrap;\n}\n\n.grade-tag {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 3px;\n}\n\n.grade-tag-label {\n    font-size: 11px;\n    line-height: 1;\n}\n\n/* Tablet & Mobile Layout Adaptations */\n@media screen and (max-width: 850px) {\n\n    /* Stack selection pieces vertically */\n    .region-selection-container {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 16px;\n    }\n\n    /* Put tabs underneath select dropdown and stack tabs */\n    .region-semester-tabs {\n        flex-direction: column;\n        width: 100%;\n        margin-top: 8px;\n    }\n\n    .region-semester-tabs button {\n        width: 100% !important;\n        /* Force tab buttons to stretch to screen width */\n        max-width: none;\n    }\n\n    /* Convert Row-Table into Flex Cards */\n    .region-table,\n    .region-table tbody,\n    .region-table tr,\n    .region-table td {\n        display: block;\n        width: 100%;\n    }\n\n    .region-table {\n        min-width: unset;\n        /* Remove the scroll-triggering min-width for mobile card view */\n        border: none;\n    }\n\n    .region-table thead {\n        display: none;\n        /* Hide normal headers entirely */\n    }\n\n    .region-table tr {\n        margin-bottom: 24px;\n        border: 1px solid #ccc;\n        border-radius: 8px;\n        /* Outline and round each row conceptually as a card */\n        padding: 8px;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n        /* Subtle shadow lift */\n    }\n\n    .region-table td {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        text-align: right;\n        padding: 12px 10px;\n        border-bottom: 1px solid #eee;\n    }\n\n    .region-table td:last-child {\n        border-bottom: none;\n        /* Bottom border unneeded on last item inside card */\n    }\n\n    .region-table td::before {\n        content: attr(data-label);\n        /* Render the dynamic label from our JS */\n        font-weight: bold;\n        text-align: left;\n        margin-right: 16px;\n        color: #444;\n    }\n\n    /* Adapt children like tag arrays for tight space */\n    .grade-tags {\n        flex-wrap: wrap;\n        justify-content: flex-end;\n        max-width: 65%;\n        /* Soft constraint so many tags wrap instead of overriding the label */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
